import { RouterProvider } from 'react-router-dom';
import { useEffect } from 'react';

import { routerAdmin, routerCoordinatorEvent, routerManagerEvent, routerManagerSeat } from 'navigation/router';

import { routerAuth } from 'navigation/routerAuth';

import { apiWrapper } from 'config/api';
import { useAppSelector } from 'redux/hooks';

type UserRole = 'admin' | 'manager_event' | 'manager_seat' | 'superadmin' | 'coordinator_event';

/**
 * Роуты приложения
 */
const AppRouter = () => {
  const { isLoggedIn, auth, data } = useAppSelector(state => state.eventUser);

  const userRole = (data?.role.name || 'manager_event') as UserRole;

  /** Установка хедеров при изменении данных пользователя */
  useEffect(() => {
    /**
     * Устанавливаем заголовки при монтировании и при изменении зависимостей
     */
    const setHeaders = () => {
      if (isLoggedIn && data?.organization?.id) {
        apiWrapper.addRequestTransform((request) => {
          request.headers = {
            'Organization-Id': data.organization.id,
            ...request.headers,
            ...auth
          };
        });
      }
    };

    setHeaders();
  }, [isLoggedIn, data?.organization?.id, auth]);

  const currentRoutes = {
    superadmin: routerAdmin,
    admin: routerAdmin,
    manager_event: routerManagerEvent,
    manager_seat: routerManagerSeat,
    coordinator_event: routerCoordinatorEvent
  };

  /**
   * Рендер основного компонента
   * @returns JSX-элемент роутера приложения
   */
  const renderContent = () => (
    <RouterProvider router={isLoggedIn ? currentRoutes[userRole] : routerAuth} />
  );

  return renderContent();
};

export default AppRouter;
